import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export type SelectFilterParams = {
  field: string;
  value: (string | number)[];
};

export type DateFilterParams = {
  dateFlag: boolean;
  fieldId: number;
  le?: number;
  ge?: number;
};

type SelectConditionParams = { field: string; value: (string | number)[] };

type DateConditionParams = { field: string; gte?: string; lte?: string };

type ConditionItem = SelectConditionParams | DateConditionParams;

export type FilterParamsItem = SelectFilterParams | DateFilterParams;

export interface GlobalSearchParams {
  query: string;
  semantic_search: boolean;
  conditions: ConditionItem[];
}

type ConfigStore = {
  language: string | null;
  updateLanguage: (data: string) => void;
};

type NonConfigStore = {
  filter: FilterParamsItem[] | null;
  updateFilter: (data: FilterParamsItem[]) => void;
  search: GlobalSearchParams | null;
  updateSearch: (data: GlobalSearchParams) => void;
};

export const useConfigStore = create<ConfigStore>()(
  subscribeWithSelector(
    immer((set, get) => ({
      // language: "en",
      language: null,
      updateLanguage(data) {
        set((state) => {
          state.language = data;
        });
      },
    }))
  ),
  // persist(

  //   {
  //     name: "global-config-store",
  //   }
  // )
);

export const useNonPersistentFilterItemsStore = create(
  immer<NonConfigStore>((set, get) => ({
    filter: [],
    search: null,
    updateFilter(data) {
      set((state) => {
        state.filter = data;
      });
    },
    updateSearch(data) {
      set((state) => {
        state.search = data;
      });
    },
  }))
);
